import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

const FormObserver = ({
  setCustomAddressValid,
  updateOrderData,
}: {
  setCustomAddressValid: (valid: boolean) => void;
  updateOrderData: (values: any) => void;
}) => {
  const { values, isValid } = useFormikContext<any>();
  const prevValuesRef = useRef(values);

  useEffect(() => {
    if (JSON.stringify(prevValuesRef.current) !== JSON.stringify(values)) {
      updateOrderData(values);
      prevValuesRef.current = values;
    }

    setCustomAddressValid(isValid);
  }, [values, isValid, setCustomAddressValid, updateOrderData]);

  return null;
};

export default FormObserver;
